import Vue from 'vue';
import Router from 'vue-router';

import Homepage from '../views/Homepage.vue';
import Registration from '../views/Registration.vue';
import Contactus from '../views/Contactus.vue';

Vue.use(Router);


export default new Router({
  routes: [
    {
      path: '/',
      name: 'Homepage',
      component: Homepage
    },
    {
      path: '/registration',
      name: 'Registration',
      component: Registration
    },  
    {
      path: '/contactus',
      name: 'Contactus',
      component: Contactus
    },

  ],
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",

  });


